import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-about-page-one',
    templateUrl: './about-page-one.component.html',
    styleUrls: ['./about-page-one.component.scss'],
    standalone: false
})
export class AboutPageOneComponent implements OnInit {

  aboutUsPages: AboutUsPages;
  img: string;
  constructor(private aboutUsService: AboutUsService, private sanitizer: DomSanitizer,
    private seoService: SeoService
  ) { }

  createImgPath = (serverPath: string) => {
    return this.aboutUsService.createImgPath(serverPath);
  }

  ngOnInit(): void {
    // Set SEO for about page
    this.seoService.updateSEO({
      title: 'About Us | Staten Driving School – 15+ Years of Experience',
      description: 'Meet the team behind Staten Island\'s trusted driving school. 15+ years of experience, certified instructors, 15,000+ happy students. Learn our story.',
      keywords: 'about Staten Driving School, certified driving instructors, Staten Island driving school history',
      url: '/about',
      canonical: 'https://statendrivingschool.com/about'
    });

    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 1);
    });
  }
  getSafeHtml(mapHtml: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(mapHtml);
  }
}

